export const notForProducts = {
  17: 'Customer ID document is expiring',
  19: 'Ametlikud Teadaanded notification',
  27: 'New customer created'
}
